import { all, takeLatest, takeEvery, put } from 'redux-saga/effects'
import { request } from '../../../../../admincore'

import { getAccountDetails } from '../../../api'
import actions from './actions'

// const getCompanySelect = state => state.companySelect

function* LOAD() {
  const companySelect = localStorage.getItem('app.settings.company')

  if (!companySelect || companySelect === -1) {
    return
  }
  yield put(request(getAccountDetails(companySelect), actions.LOAD))
}

export default function* rootSaga() {
  yield all([takeLatest(actions.LOAD, LOAD), takeEvery('company/save', LOAD)])
}
